import React from "react";
import "./TeamMem.css";

function TeamMember(props) {
  return (
    <div className="m-3">
      <div className="team-card">
        <div className="team-member-info">
          <h3>{props.name}</h3>
          <span className="member-title">{props.title}</span>
          <div className="member-links">
            <a target="_blank" rel="noreferrer" href={props.email}>
              <i className="fa fa-envelope"></i> Email
            </a>
            <a target="_blank" rel="noreferrer" href={props.linkedin}>
              <i className="fa-brands fa-linkedin-in"></i> LinkedIn
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TeamMember;
